import { createSlice } from '@reduxjs/toolkit';
import { fetchDashboardStatsAsyncThunk } from './dashboardThunk';

const initialState = {
  stats: {
    totalUsers: 0,
    newUsersThisMonth: 0,
    activeSubscribers: 0,
    totalCourses: 0,
    upcomingLiveEvents: [],
  },
  isLoading: false,
  error: null,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStatsAsyncThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStatsAsyncThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.stats = {
          totalUsers: action.payload.totalUsers,
          newUsersThisMonth: action.payload.newUsersThisMonth,
          activeSubscribers: action.payload.activeSubscribers,
          totalCourses: action.payload.totalCourses,
          upcomingLiveEvents: action.payload.upcomingLiveEvents,
        };
        state.error = null;
      })
      .addCase(fetchDashboardStatsAsyncThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Failed to fetch dashboard statistics';
      });
  },
});

export const { clearError } = dashboardSlice.actions;
export default dashboardSlice.reducer;

